module.exports = __webpack_public_path__ + "static/media/swiftness-aura.28ad5129.png";